var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-message mb-2",
      class: _vm.getMessageBoxStyle,
      attrs: { role: "alert" },
    },
    [
      _c("div", { staticClass: "grid pt-2 pb-2 pl-3 pr-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "rb-message__title" },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "rb-message__text" }, [_vm._t("text")], 2),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }